<template>
  <div>
    <PageTitle :title="$t('global.tickets')">
      <template #actions>
        <Btn @click="requestMigration" v-if="canMigrate" variant="primaryOutline" class="mr-2">
          Request Migration
        </Btn>

        <Btn @click="addTicket">
          <Icon icon="add" class="mr-2" />
          {{ $t("global.ticket") }}
        </Btn>
      </template>
    </PageTitle>
    <TicketsTable :tickets="tickets" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import ContactSupport from "@/components/smart/modals/ContactSupport";
import Icon from "@/components/display/icon/Icon";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";
import TicketsTable from "@/components/smart/tables/TicketsTable";

export default {
  name: "TicketsList",
  components: {
    Btn,
    Icon,
    PageTitle,
    TicketsTable,
  },
  setup(props, { root }) {
    const addTicket = () => {
      store.dispatch("modals/open", {
        template: ContactSupport,
      });
    };

    const canMigrate = computed(() => {
      return process.env.VUE_APP_SUPPORT_MIGRATION_DEPARTMENT;
    });

    const requestMigration = () => {
      root.$router.push({ name: "request-migration" });
    };
    const tickets = computed(() => store.state.tickets);

    onMounted(() => {
      store.dispatch("tickets/getList");
    });

    return { addTicket, tickets, requestMigration, canMigrate };
  },
};
</script>
